import BuilderContainer from './BuilderContainer';
import Loading from '../../Shared/Loading';
import WorkflowEngineHeader from '../../WorkflowEngine/WorkflowEngineHeader';
import { WorkflowEngineConfig } from '../../WorkflowEngine/workflowEngineDictionary';

export default {
  container: <BuilderContainer />,
  loadingView: (
    <>
      <WorkflowEngineHeader />
      <Loading sx={{ marginTop: '70px' }} />
    </>
  )
} as WorkflowEngineConfig;
